import { render, staticRenderFns } from "./add-prize.vue?vue&type=template&id=2979db30&scoped=true"
import script from "./add-prize.vue?vue&type=script&lang=js"
export * from "./add-prize.vue?vue&type=script&lang=js"
import style0 from "./add-prize.vue?vue&type=style&index=0&id=2979db30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2979db30",
  null
  
)

export default component.exports